<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-6">


                <div class="faq">

                    <h4>Frequently Asked Questions</h4> <br />


                    <div *ngFor="let faq of Data">



                        <ngb-accordion #acc="ngbAccordion">
                            <ngb-panel>
                                <ng-template ngbPanelTitle>
                                    <h5 class="mb-0 panel-title">
                                        <a class="collapsed">
                                            {{faq.question}}
                                            <i class="nc-icon nc-minimal-down"></i>
                                        </a>
                                    </h5>
                                </ng-template>
                                <ng-template ngbPanelContent>

                                    <div [innerHTML]="faq.answer"></div>


                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>

                    </div>


                </div>
            </div>

            <div class="col-md-5 col-sm-6 ml-auto mr-auto">
                <div class="card card-register">
                    <h3 class="card-title text-default">Support Portal Login</h3>
                    <form class="register-form">
                        <label>Practice Number</label>
                        <input [(ngModel)]="search_practice_number" name="search_practice_number" type="text"
                            class="form-control" placeholder="" value="" [ngModelOptions]="{standalone: true}">


                        <button class="btn btn-default btn-block btn-round" (click)="open(Login,'')">Search</button>



                        <label class="text-danger">{{
                            result_message }}</label>
                    </form>
                    <!--                     
                    <div class="forgot">
                        <a href="javascript:void(0)" class="btn btn-link btn-danger">Forgot
                            password?</a>
                    </div> -->
                </div>
            </div>


            <ng-template #Login size="lg" let-c="close" let-d="dismiss">
                <div class="modal-header mogal-lg no-border-header text-center">
                    <button type="button" class="close" (click)="d('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h6 class="text-muted">User Details</h6>
                    <h3 class="modal-title text-center">Doctor Portal Login</h3>
                    <p>Log in to your account</p>
                </div>


                <div class="modal-body">



                    <div class="row bg-light mt-1">
                        <div class="col col-sm-4 ">
                            Username
                        </div>
                        <div class="col col-sm-8">

                            <select class="dropdown w-100" [(ngModel)]="selected_username_id" id="selected_username_id"
                                (ngModelChange)="get_user_databases_on_change($event)">

                                <option *ngFor="let user_item of processed_data" [value]="user_item._id"> {{
                                    user_item.username }}</option>


                            </select>

                        </div>




                    </div>



                    <div class="row bg-light mt-1">
                        <div class="col col-sm-4 ">
                            Database
                        </div>
                        <div class="col col-sm-8">

                            <select class="dropdown w-100" [(ngModel)]="selected_database" id="selected_database">

                                <option *ngFor="let database_item of selected_user_object.databases"
                                    [value]="database_item.database"> {{
                                    database_item.database_name }}</option>


                            </select>

                        </div>




                    </div>

                    <!-- <div class="row ">
                        <div class="col col-sm-4">
                            User Name
                        </div>
                        <div class="col col-sm-8" >
                            {{selected_user_object.username}}
                        </div>




                    </div> -->

                    <div class="row bg-light mt-1 ">
                        <div class="col col-sm-4">
                            Email
                        </div>
                        <div class="col col-sm-8">
                            {{selected_user_object.dremail}}
                        </div>




                    </div>
                    <div class="row mt-1">
                        <div class="col col-sm-4">
                            Mobile
                        </div>
                        <div class="col col-sm-8">
                            {{selected_user_object.drcell}}
                        </div>




                    </div>

                    <div class="row mt-1">
                        <div class="col col-sm-4">

                        </div>
                        <div class="col col-sm-8">
                            <a *ngIf="this.selected_database != ''" (click)="reset_password($event)"
                                class="btn btn-link">
                                RESET PASSWORD
                            </a>
                            <a *ngIf="this.selected_database == ''" disabled>
                                RESET PASSWORD
                            </a>
                        </div>

                    </div>


                    <div *ngIf="this.reset_password_flag == true" class="row mt-1">
                        <div class="col col-sm-3">
                            Send via
                        </div>
                        <div class="col col-sm-5">
                            <select class="dropdown w-100" [(ngModel)]="selected_reset_method"
                                id="selected_reset_method">

                                <option value="email">
                                    Email</option>
                                <option value="sms">SMS</option>
                                <option value="support">
                                    Support</option>

                            </select>
                        </div>
                        <div class="col col-sm-4">

                            <a class="btn btn-success btn-sm" (click)="reset_password_submit($event)">
                                Send OTP!
                            </a>
                        </div>

                    </div>

                    <div *ngIf="this.loading == true" class="row mt-1">
                        <div class="loader">

                        </div>
                    </div>

                    <!-- <div class="form-group">
                            <label>Email</label>
                            <input type="text" value="" placeholder="Email" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" value="" placeholder="Password" class="form-control" />
                        </div>
                        <button class="btn btn-block btn-round">Log in</button> -->
                </div>
                <!-- <div class="modal-register modal-footer no-border-footer">
                        <span class="text-muted text-center">Looking <a>create an account</a> ?</span>
                    </div> -->
                <div class="modal-footer">
                    <div class="left-side">
                        <button type="button" class="btn btn-danger" (click)="c('Close click')">Never mind</button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <button *ngIf="this.selected_database != ''" type="button" class="btn btn-success"
                            (click)="c('Continue')">Continue</button>
                        <button *ngIf="this.selected_database == ''" type="button" disabled class="btn btn-light"
                            (click)="c('Continue')">Continue</button>
                    </div>
                </div>
            </ng-template>


        </div>
    </div>
</div>